import {
    createSelector,
    createStructuredSelector,
} from 'reselect';
import { initialState } from './reducer';
import { RootState } from '../../interface';
import { Namespace } from '../../enum';

const selectState = (state: RootState) => state[Namespace.App] || initialState;

export const selectLoading = createSelector(selectState, state => Boolean(Object.keys(state.loadingStatus).length));
export const selectError = createSelector(selectState, state => state.error);
export const selectCurrentLevelId = createSelector(selectState, state => state.currentLevelId);
export const selectCurrentPath = createSelector(selectState, state => state.routingPath);

export const mapStateToProps = createStructuredSelector({
    isLoading: selectLoading,
    error: selectError,
    currentLevelId: selectCurrentLevelId,
    routingPath: selectCurrentPath,
});

/**
 * State props by selectors
 */
export type State = ReturnType<typeof mapStateToProps>;
